import {createReducer} from '../utility'




export const firmApplication = createReducer({},{
    "FETCH_FIRM_APPLICATION_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                application: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_APPLICATIONS"(state, {data}){
        return{
            ...state,
            application: null
        }
    }
})

export const firmApplicationSubmitted = createReducer({},{
    "SUBMIT_FIRM_APPLICATION_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                response: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_APPLICATIONS"(state, {data}){
        return{
            ...state,
            response: null
        }
    } 
})

export const updatedFirmApplication = createReducer({},{
    "SUBMIT_FIRM_APPLICATION_SUCCESSFUL"(state, {data}){
        if(data){
            return {
                ...state,
                status: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_APPLICATIONS"(state, {data}){
        return{
            ...state,
            status: null
        }
    }  
})


export const hasUpdatedFirm = createReducer({},{
    "FIRM_APPLICATION_UPDATED"(state, {data}){
        if(data){
            return {
                ...state,
                updateId: data
            }
        }else{
            return{
                ...state
            }
        }
    },
    "CLEAR_APPLICATIONS"(state, {data}){
        return{
            ...state,
            updateId: null
        }
    }
})